import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import { ICustomerData } from '@epi-models/pages/Home';
import { IMPERSONATION_API_URL, USER_API_URL } from '@epi-constants/user';
import { GET_USER_DETAILS_API_TAG } from '@epi-api/apiTags';

export const getImpersonationToken = (guid: string): Promise<any> => {
  return get(`${IMPERSONATION_API_URL}/${guid}`);
};

export const getDetails = async (): Promise<ICustomerData> =>
  get<ICustomerData>(`${USER_API_URL}/details`);
export const userApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getDetails: build.query<ICustomerData, void>({
      async queryFn(_arg, api) {
        try {
          const data = await getDetails();
          return { data };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 0,
      providesTags: [GET_USER_DETAILS_API_TAG]
    })
  })
});

export const { useGetDetailsQuery } = userApi;
